import { useCallback, useEffect, useState } from "react";

import toastMessages from 'stores/toastMessages';
import FinanceService from 'services/FinanceService';
import Supplier from "models/Supplier";

export default function useSuppliers() {
    const [suppliers, setSuppliers] = useState<Supplier[]>([])

    const fetchSuppliers = useCallback(async function () {
        try {
            const _suppliers = await FinanceService.getSuppliers()
            setSuppliers(_suppliers)
        } catch (e) {
            toastMessages.showSystemError()
        }
    }, [])

    useEffect(() => { fetchSuppliers() }, [fetchSuppliers])

    return suppliers
}
